import angular from 'angular'
import { GruzFirms, GruzAvto, GruzPricep } from './models'
import ngResource from 'angular-resource'

export default angular
  .module('gruz.models', [ngResource])
  .factory('GruzFirms', GruzFirms)
  .factory('GruzAvto', GruzAvto)
  .factory('GruzPricep', GruzPricep).name
